var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-widget-geogrid-tabs"},[_c('div',{staticClass:"btn-group-justified m-b-1",attrs:{"role":"group"}},_vm._l((_vm.tabs[_vm.pageState]),function(tab){return _c('a',{class:[
        'btn btn-secondary radio-btn',
        { active: _vm.pageTab === tab.val, 'pseudo-disabled': _vm.disabledTab(tab.val)}
      ],attrs:{"id":`geogrids-tab-${_vm.pageState}-${tab.val}`},on:{"click":function($event){return _vm.goTo(tab.val)}}},[_vm._v("\n      "+_vm._s(tab.title)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }